import React from 'react';

function Portfolio() {
  const portfolioItems = [
    {
      image: './Images/IMG033.png',
      title: 'Modern Interior Design',
      description: 'A luxurious interior design for a residential home.'
    },
   
    {
      image: './Images/IMG032.png',
      title: 'Home Interior',
      description: 'A full-scale home interior with modern elements.'
    },
    {
      image: './Images/IMG030.png' ,
      title: 'Home Renovation',
      description: 'A full-scale home renovation project with modern elements.'
    }

  ];

  return (
    <section id="portfolio" className="py-16 bg-white">
      <div className="container mx-auto text-center px-4">
        <h2 className="text-3xl font-bold mb-8">Our Portfolio</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item, index) => (
            <div key={index} className="bg-gray-100 p-4 shadow-md">
              <img src={item.image} alt={item.title} className="w-full h-48 object-cover" />
              <h3 className="text-xl font-semibold mt-4">{item.title}</h3>
              <p className="mt-2">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
